/**
 * 표시 포맷 유틸 — 비용 KRW, 날짜, 토큰 등.
 */

const KRW = new Intl.NumberFormat('ko-KR', { style: 'currency', currency: 'KRW', maximumFractionDigits: 0 });
const KRW_PRECISE = new Intl.NumberFormat('ko-KR', { style: 'currency', currency: 'KRW', maximumFractionDigits: 2 });
const NUM = new Intl.NumberFormat('ko-KR');

export function formatKrw(n: number | null | undefined, precise = false): string {
  if (n == null) return '—';
  return (precise && Math.abs(n) < 100 ? KRW_PRECISE : KRW).format(n);
}

export function formatNum(n: number | null | undefined): string {
  if (n == null) return '—';
  return NUM.format(n);
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('ko-KR', { timeZone: 'Asia/Seoul', dateStyle: 'short', timeStyle: 'short' });
}

export function formatDateOnly(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('ko-KR', { timeZone: 'Asia/Seoul' });
}

export function deltaPct(curr: number, prev: number): { pct: number; sign: 'up' | 'down' | 'flat' } {
  if (prev === 0) return { pct: curr === 0 ? 0 : 100, sign: curr === 0 ? 'flat' : 'up' };
  const pct = ((curr - prev) / prev) * 100;
  return { pct: Math.abs(pct), sign: pct > 0.5 ? 'up' : pct < -0.5 ? 'down' : 'flat' };
}

const SOURCE_COLORS: Record<string, string> = {
  anthropic: '#6E8FFF',
  clova_stt: '#5FBE7B',
  aws_s3: '#E8B95A',
  aws_ec2: '#E25C5C',
};

export function sourceColor(source: string): string {
  return SOURCE_COLORS[source] ?? '#8B8B92';
}

export function sourceLabel(source: string): string {
  switch (source) {
    case 'anthropic': return 'Claude API';
    case 'clova_stt': return 'Clova STT';
    case 'aws_s3': return 'AWS S3';
    case 'aws_ec2': return 'AWS EC2';
    default: return source;
  }
}

export function featureLabel(feature: string): string {
  switch (feature) {
    case 'chat': return '채팅';
    case 'onboarding': return '온보딩';
    case 'summarize': return '요약';
    case 'todo_extract': return 'TODO 추출';
    case 'todo_status': return 'TODO 상태추적';
    case 'calendar_extract': return '캘린더 추출';
    case 'stt': return 'STT';
    default: return feature;
  }
}
